import React, { Component } from 'react'

export class Statistics extends Component {
  render() {
    return (
      <div>
        <h3>Statistics</h3>
      </div>
    )
  }
}

export default Statistics
